import { SET_PAYMENT_CONTRACTS } from '@/utils/store/mutationTypes'

export default {
  /**
   * Sets order bundles with open payments.
   *
   * @param state
   * @param paymentContracts
   */
  [SET_PAYMENT_CONTRACTS] (state, paymentContracts) {
    state.openPayments = paymentContracts
  }
}
